import { Suspense, useEffect } from 'react';
import { IonApp, isPlatform } from '@ionic/react';
import { setupIonicReact } from '@ionic/react';
import { App as AppCapacitor } from '@capacitor/app';
import { push } from 'redux-first-history';
import { back } from 'redux-first-history/build/es6/actions';

/* Core CSS required for Ionic components to work properly */
import '@ionic/react/css/core.css';

/* Basic CSS for apps built with Ionic */
import '@ionic/react/css/normalize.css';
import '@ionic/react/css/structure.css';
import '@ionic/react/css/typography.css';

/* Optional CSS utils that can be commented out */
import '@ionic/react/css/padding.css';
import '@ionic/react/css/float-elements.css';
import '@ionic/react/css/text-alignment.css';
import '@ionic/react/css/text-transformation.css';
import '@ionic/react/css/flex-utils.css';
import '@ionic/react/css/display.css';

/* Theme variables */
import './theme/index.scss';
import ApiService from './services/api.service';
import { Menu } from './pages/Menu/Menu';
import { AppRouter } from './App.router';
import { HistoryRouter as Router } from 'redux-first-history/rr6';
import { history, store, useAppDispatch } from './store/store';
import SoundLoader from './components/SoundLoader/SoundLoader';
import KeepScreenAwake from './components/KeepScreenAwake/KeepScreenAwake';
import ErrorHandler from './components/ErrorHandler/ErrorHandler';
import GetCurrentSession from './components/GetCurrentSession/GetCurrentSession';
import CheckLocationPermissions from './components/CheckLocationPermissions/CheckLocationPermissions';
import { currentTrialSelector } from './store/slices';
import { TextZoom } from '@capacitor/text-zoom';
import { Keyboard } from '@capacitor/keyboard';
require('dotenv').config();

ApiService.init(process.env.REACT_APP_BASE_URL);

setupIonicReact({ mode: 'ios', scrollAssist: false });

TextZoom.set({ value: 1 });

Keyboard.setAccessoryBarVisible({ isVisible: true });

const App: React.FC = () => {
  const dispatch = useAppDispatch();

  useEffect(() => {
    if (isPlatform('android')) {
      AppCapacitor.addListener('backButton', (data) => {
        const currentTrial = currentTrialSelector(store.getState());
        if (!currentTrial) {
          const pathName = history.location.pathname;

          if (pathName === '/home' || pathName === '/welcome' || !data.canGoBack) {
            AppCapacitor.exitApp();
          } else if (pathName === '/end-of-session') {
            dispatch(push('/home'));
          } else {
            dispatch(back());
          }
        }
      });

      return () => {
        AppCapacitor.removeAllListeners();
      };
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <IonApp>
      <Suspense fallback={''}>
        <Router history={history}>
          {process.env.NODE_ENV === 'development' && <Menu />}
          <AppRouter />
        </Router>
      </Suspense>
      <SoundLoader />
      <KeepScreenAwake />
      <ErrorHandler />
      <GetCurrentSession />
      <CheckLocationPermissions />
    </IonApp>
  );
};

export default App;
